import MuiTabs, {TabsProps as MuiTabsProps} from '@mui/material/Tabs'

import './styles.scss'

export const Tabs: React.FC<MuiTabsProps> = ({
  children,
  className,
  ...rest
}) => {
  return (
    <MuiTabs
      className={`override-tabs ${className}`}
      {...rest}
    >
      {children}
    </MuiTabs>
  )
}
